import { render, staticRenderFns } from "./SSCommentListView.vue?vue&type=template&id=0bc62c6e&scoped=true&"
import script from "./SSCommentListView.vue?vue&type=script&lang=js&"
export * from "./SSCommentListView.vue?vue&type=script&lang=js&"
import style0 from "./SSCommentListView.vue?vue&type=style&index=0&id=0bc62c6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc62c6e",
  null
  
)

export default component.exports